import EnumType from "@/app/shared/EnumType.js";

const values = {
  Muck: 0, 
  Remuck: 1,
  Hauling: 2
};

export default EnumType.generate(values, "GradeControl.TimesheetOperationType.");